
export class DateTimeDifferenceValueConverter {
	toView(startDate, endDate) {

		if (startDate && endDate) {
			let diff = (new Date(startDate).getTime() - new Date(endDate).getTime()) / 1000;
			diff /= 60;
			if(diff < 60)
				return `${Math.abs(Math.round(diff))} Minuits`;

			diff /= (60 * 60);
			return `${Math.abs(Math.round(diff))} Hour`;
        } else {
            return "";
        }
    }
}